@if (federations.length) {
	<ul class="labelled-list">
		@for (federation of federations; track federation.federationId) {
			<li>
				<div class="federation-logo">
					@if (federation.logoUrl) {
						<img [src]="federation.logoUrl" />
					}
				</div>
				<strong class="label">{{federation.federationName}}</strong>
		
				<div class="actions-subsidiaries">
					@if (currentUserIsSupport$ | async) {
						<a class="btn btn-secondary"
							[ngbTooltip]="'Actions.Edit' | translate"
							[routerLink]="getFederationDetailPath(federation.federationId)">
							<i class="far fa-pencil"></i>
						</a>
					}
					@if (federation.federationId) {
						<div class="btn-group" ngbDropdown placement="bottom-right">
							<button (click)="redirectToFederation(federation.federationId)" class="btn btn-primary">
								{{ 'Actions.Access' | translate }}
							</button>
							<button id="button-split"
									type="button"
									ngbDropdownToggle data-cy="DropdownToggle"
									class="btn btn-primary dropdown-toggle dropdown-toggle-split">
							</button>
							<div ngbDropdownMenu class="dropdown-menu">
								<button ngbDropdownItem
										(click)="redirectToFederationNewTab(federation.federationId)"
										class="dropdown-item" translate="Actions.AccessNewTab" data-cy="AccessNewTab">
								</button>
							</div>
						</div>
					}
				</div>
			</li>
		}
	</ul>
}
